module.exports = __webpack_public_path__ + "img/custom_client_seed_2_en.0dfa9bc3.png";